export default "__VITE_ASSET__fQCu38Cj__"